import { useEffect, useState } from 'react';
import { Gavel, Trophy } from 'lucide-react';
import { api, fcfa } from '../lib/api';
import CountdownTimer from './CountdownTimer';

export function LiveAuctionPanel({ liveId }) {
  const [auction, setAuction] = useState(null);
  const [bids, setBids] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get(`/lives/${liveId}`);
        if (!alive) return;
        setAuction(data.active_auction || null);
        if (data.active_auction) {
          const { data: b } = await api.get(`/auctions/${data.active_auction.auction_id}/bids`);
          if (alive) setBids(b.slice(0, 6));
        } else setBids([]);
      } catch {}
    };
    load();
    const id = setInterval(load, 1500);
    return () => { alive = false; clearInterval(id); };
  }, [liveId]);

  if (!auction) return null;
  const ended = auction.status !== 'running';
  return (
    <div className="mt-3 rounded-xl border border-amber-500/40 bg-amber-500/5 p-3" data-testid="seller-auction-panel">
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-amber-300"><Gavel className="h-3.5 w-3.5" />Enchère en cours · {auction.product_name}</div>
      <div className="mt-2 flex items-center justify-between gap-3">
        <div>
          <div className="font-mono-num text-2xl font-extrabold text-amber-400" data-testid="seller-current-price">{fcfa(auction.current_price)}</div>
          <div className="text-xs text-slate-300">Meneuse : <span className="font-bold text-white" data-testid="seller-top-bidder">{auction.top_bidder_name || '—'}</span> · {auction.bids_count} enchère{auction.bids_count > 1 ? 's' : ''}</div>
        </div>
        {!ended && <CountdownTimer endsAt={auction.ends_at} size={64} />}
      </div>
      {ended ? (
        <div className="mt-2 text-sm text-emerald-300 flex items-center gap-1" data-testid="seller-auction-winner"><Trophy className="h-4 w-4" />Gagnante : {auction.winner_name || '—'} · {fcfa(auction.final_price)}</div>
      ) : (
        <div className="mt-2 space-y-1 max-h-24 overflow-y-auto pretty-scroll" data-testid="seller-bid-feed">
          {bids.length === 0 && <div className="text-xs text-slate-500">Aucune enchère pour l'instant…</div>}
          {bids.map((b) => (
            <div key={b.bid_id} className="flex justify-between text-xs px-2 py-1 rounded bg-slate-900/60">
              <span className="text-slate-200">{b.user_name}</span><span className="font-mono-num text-amber-400">{fcfa(b.amount)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
